// extracted by mini-css-extract-plugin
export default {"payBillSide":"PayBillSide_payBillSide__-Xq0g","description":"PayBillSide_description__10wV0","buttons":"PayBillSide_buttons__q-W1m","button":"PayBillSide_button__B+viy"};